import { useEffect, useRef, useState } from "react";
import { adminUsersPath } from "../adminNav";

// Account chip in the topbar: a square initial-chip that opens a small menu with
// the signed-in email, an Admin link (admins only), and a sign-out action.
// Closes on outside-click or Escape.
export function UserMenu({
  email,
  isAdmin,
  onSignOut,
}: {
  email: string | null;
  isAdmin?: boolean;
  onSignOut: () => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="user-menu" ref={ref}>
      <button
        className="user-avatar"
        aria-label="Account menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 20c0-3.6 3.1-5.5 7-5.5s7 1.9 7 5.5" />
        </svg>
      </button>
      {/* Deliberately not role="menu": that role promises arrow-key navigation
          we don't implement, and the email line is not a valid menu child. */}
      {open && (
        <div className="user-dropdown">
          <div className="user-email" title={email ?? undefined}>
            {email ?? ""}
          </div>
          {isAdmin && (
            <a className="user-item" href={adminUsersPath}>
              Admin
            </a>
          )}
          <button
            className="user-signout"
            onClick={() => {
              setOpen(false);
              onSignOut();
            }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
